import * as React from 'react';
import { useIntl } from 'react-intl';
import type { CountryEnum } from '@foundershub/api-client';

export function useRegionNames() {
  const { locale } = useIntl();
  return React.useMemo(() => new Intl.DisplayNames([locale], { type: 'region' }), [locale]);
}

export function useCountryDropdownOptions(countries: Array<CountryEnum> | undefined) {
  const { locale } = useIntl();
  const regionNames = useRegionNames();
  const countryOptions = React.useMemo(() => {
    const collator = new Intl.Collator(locale);
    return typeof regionNames !== 'undefined' && countries
      ? countries
          .map((slug) => ({ label: regionNames.of(slug.toUpperCase()) || slug.toUpperCase(), value: slug }))
          .sort((a, b) => collator.compare(a.label, b.label))
      : [];
  }, [countries, regionNames]);
  return countryOptions;
}

export const countriesWithoutPostalCodes: Array<CountryEnum> = [
  'ao',
  'ag',
  'aw',
  'bs',
  'bz',
  'bj',
  'bw',
  'bf',
  'bi',
  'cm',
  'cf',
  'km',
  'cg',
  'cd',
  'ck',
  'ci',
  'dj',
  'dm',
  'gq',
  'er',
  'fj',
  'tf',
  'gm',
  'gh',
  'gd',
  'gn',
  'gy',
  'hk',
  'ie',
  'jm',
  'ke',
  'ki',
  'mo',
  'mw',
  'ml',
  'mr',
  'mu',
  'ms',
  'nr',
  'nu',
  'kp',
  'pa',
  'qa',
  'rw',
  'kn',
  'lc',
  'st',
  'sa',
  'sc',
  'sl',
  'sb',
  'so',
  'za',
  'sr',
  'sy',
  'tz',
  'tl',
  'tk',
  'to',
  'tt',
  'tv',
  'ug',
  'ae',
  'vu',
  'ye',
  'zw',
];
